import React__default, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faQuestionCircle, faCog, faBars } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index.js';
import { NvMenu } from '../NvMenu/component.js';
import component from '../NvUserIcon/component.js';
import styles from './styles.module.scss.js';
import propsToClass from '../../../helpers/propsToClass.js';

/* eslint-disable import/no-extraneous-dependencies */
/**
 * @description Nimvelo Topbar component
 * @props apps, brand, brandSrc, className, customerName, fullWidth, helpMenuItems, inverted, product, productSrc, resellerName,
 * settingsMenuItems, showBeta, userEmail, userMenuItems
 */
const NvTopbar = ({ apps = [], brand, brandSrc, className = '', customerName, fullWidth = false, helpMenuItems = [], inverted = false, product, productSrc, resellerName, settingsMenuItems = [], showBeta, userEmail, userMenuItems = [], showLeftHamburger = false, showRightHamburger = false, onHamburgerClick, hamburgerBreakpoint, }) => {
    const [breakpointMatch, setBreakpointMatch] = useState(true);
    const helpIcon = React__default.createElement(FontAwesomeIcon, { icon: faQuestionCircle });
    const settingsIcon = React__default.createElement(FontAwesomeIcon, { icon: faCog });
    const userIcon = React__default.createElement(component, { pixelSize: 40, userEmail: userEmail });
    const leftHamburgerIcon = (React__default.createElement(FontAwesomeIcon, { className: styles.hamburger_left, icon: faBars, onClick: () => {
            if (onHamburgerClick) {
                onHamburgerClick('left');
            }
        } }));
    const rightHamburgerIcon = (React__default.createElement(FontAwesomeIcon, { className: styles.hamburger_right, icon: faBars, onClick: () => {
            if (onHamburgerClick) {
                onHamburgerClick('right');
            }
        } }));
    // breakpoint logic
    useEffect(() => {
        const breakpoint = window.matchMedia(`(max-width: ${hamburgerBreakpoint}px), (max-height: 700px)`);
        const watchBreakpoint = (e) => {
            setBreakpointMatch(e.matches);
        };
        if (hamburgerBreakpoint) {
            setBreakpointMatch(breakpoint.matches);
            if (breakpoint.addEventListener) {
                breakpoint.addEventListener('change', watchBreakpoint);
            }
            else {
                breakpoint.addListener(watchBreakpoint);
            }
        }
        return () => {
            if (breakpoint.removeEventListener) {
                breakpoint.removeEventListener('change', watchBreakpoint);
            }
            else {
                breakpoint.removeListener(watchBreakpoint);
            }
        };
    }, [hamburgerBreakpoint]);
    const content = {
        appSwitcher: (React__default.createElement(NvMenu, { type: "grid", align: "right", data: apps, size: "large", itemIconSize: "4em" })),
        beta: React__default.createElement("sup", { className: styles.beta }, "beta"),
        brand: React__default.createElement("div", { className: styles.brand }, brand),
        brandImg: React__default.createElement("img", { className: styles.brandImg, src: brandSrc, alt: "Logo" }),
        customer: React__default.createElement("span", { className: styles.customer_name }, customerName),
        helpDropdown: React__default.createElement(NvMenu, { icon: helpIcon, align: "right", data: helpMenuItems }),
        product: React__default.createElement("span", { className: styles.product }, product),
        productImg: (React__default.createElement("img", { className: styles.productImg, src: productSrc, alt: "Logo" })),
        reseller: React__default.createElement("span", { className: styles.reseller_name }, resellerName),
        settings: (React__default.createElement(NvMenu, { icon: settingsIcon, align: "right", data: settingsMenuItems })),
        userMenu: (React__default.createElement(NvMenu, { icon: userIcon, align: "right", data: userMenuItems, size: "large" })),
    };
    const hasApps = apps.length > 0;
    const hasHelpItems = helpMenuItems.length > 0;
    const hasSettingsItems = settingsMenuItems.length > 0;
    const hasUserItems = userMenuItems.length > 0;
    return (React__default.createElement("div", { className: propsToClass(styles.topbar, [
            [className, !!className],
            [styles.inverted, inverted],
            [styles.full_width, fullWidth],
        ]), "data-rggridarea": "topbar" },
        React__default.createElement("div", { className: styles.left_container },
            showLeftHamburger && breakpointMatch && leftHamburgerIcon,
            brand && content.brand,
            brandSrc && content.brandImg,
            product && content.product,
            showBeta && content.beta,
            productSrc && content.productImg),
        React__default.createElement("div", { className: styles.right_container },
            resellerName && content.reseller,
            customerName && content.customer,
            hasHelpItems && content.helpDropdown,
            hasSettingsItems && content.settings,
            hasApps && content.appSwitcher,
            hasUserItems && content.userMenu,
            showRightHamburger && breakpointMatch && rightHamburgerIcon)));
};

export { NvTopbar, NvTopbar as default };
//# sourceMappingURL=component.js.map
